import { render, staticRenderFns } from "./AppScreenConfig.vue?vue&type=template&id=498c5be2&scoped=true"
import script from "./AppScreenConfig.vue?vue&type=script&lang=js"
export * from "./AppScreenConfig.vue?vue&type=script&lang=js"
import style0 from "./AppScreenConfig.vue?vue&type=style&index=0&id=498c5be2&lang=scss&scoped=true"
import style1 from "./AppScreenConfig.vue?vue&type=style&index=1&id=498c5be2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c5be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498c5be2')) {
      api.createRecord('498c5be2', component.options)
    } else {
      api.reload('498c5be2', component.options)
    }
    module.hot.accept("./AppScreenConfig.vue?vue&type=template&id=498c5be2&scoped=true", function () {
      api.rerender('498c5be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/appScreenManage/AppScreenConfig.vue"
export default component.exports